import { useEffect } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { useParams } from 'react-router-dom';
import { FormControlLabel, FormHelperText, MenuItem, Select } from '@mui/material';
import { useGetWorkbenchTypesQuery } from '~/api/v2/hooks';

const InstanceTypeField = () => {
  const projectId = +useParams().projectid!;
  const { data: typesData } = useGetWorkbenchTypesQuery({ projectId });
  const { watch, control, setValue } = useFormContext();
  const selectedWorkbenchGroup = watch('workbenchGroup');
  const watchInstanceType = watch('instance_type');

  useEffect(() => {
    if (
      watchInstanceType &&
      typesData &&
      !typesData[selectedWorkbenchGroup]?.filter(({ id }) => watchInstanceType === id).length
    ) {
      setValue('instance_type', '', {
        shouldDirty: true,
        shouldValidate: false,
      });
    }
  }, [selectedWorkbenchGroup]);

  return (
    <FormControlLabel
      required
      label="INSTANCE TYPE"
      control={
        <Controller
          name="instance_type"
          control={control}
          render={({ field, fieldState }) => (
            <>
              <FormHelperText error={!!fieldState.error}>{fieldState.error?.message}</FormHelperText>
              <Select
                {...field}
                value={field.value ?? ''}
                disabled={!selectedWorkbenchGroup}
                error={!!fieldState.error}
              >
                {typesData &&
                  typesData[selectedWorkbenchGroup]?.map(({ name, id }) => (
                    <MenuItem value={id} key={id}>
                      {name}
                    </MenuItem>
                  ))}
              </Select>
            </>
          )}
        />
      }
    />
  );
};

export default InstanceTypeField;
